import React from 'react';

const Icon = (props) => {
    return (
        <div
            title={props.title}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '30px',
                height: '100%',
                fontSize: '18px',
            }}
            onClick={props.onClick}
        >
            <span
                style={{ fontSize: 'inherit', cursor: 'pointer' }}
                className="material-symbols-outlined"
            >
                {props.icon}
            </span>
        </div>
    );
};

export default Icon;